import { render, staticRenderFns } from "./ApplyingRecordHistoryView.vue?vue&type=template&id=625cd18f&scoped=true&"
import script from "./ApplyingRecordHistoryView.vue?vue&type=script&lang=js&"
export * from "./ApplyingRecordHistoryView.vue?vue&type=script&lang=js&"
import style0 from "./ApplyingRecordHistoryView.vue?vue&type=style&index=0&id=625cd18f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625cd18f",
  null
  
)

export default component.exports